<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item prop="serviceUrl" label="一级服务地址">
                        <el-input v-model="form.serviceUrl" maxlength="400"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    deptId:"",
                    serviceUrl:"",
                },
                rules: {
                    serviceUrl: [
                        { required: true, message: '请输入一级服务地址', trigger: 'blur' }
                    ],
                }
            }
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=data.deptId;
                this.form.id=data.id;
                this.form.serviceUrl=data.serviceUrl;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.onelevelServiceUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            serviceUrl:this.form.serviceUrl,
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/sys/onelevel/Update.vue